import moment from "moment";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ORANGE, IconBack } from "./ui";

const Banner = () => {
  const navigate = useNavigate();
  const offerprice = useSelector((state: any) => state.upsell.offerprice);
  const dictionaries = useSelector((state: any) => state.flight.dictionaries);

  const iti = offerprice?.flightdetails?.[0];
  const firstSeg = iti?.segments?.[0];
  const lastSeg = iti?.segments?.[iti?.segments?.length - 1];

  const regionFor = (code: string) =>
    (dictionaries && dictionaries.airport?.[code]?.region) || code || "—";

  const from = firstSeg ? regionFor(firstSeg.departurecode) : "—";
  const to = lastSeg ? regionFor(lastSeg.arrivalCode) : "—";
  const depDate = firstSeg?.departuredatetime
    ? moment(firstSeg.departuredatetime).format("ddd, MMM DD")
    : null;
  const cabin = offerprice?.travelers?.fareList?.[0]?.cabinclasstype;

  return (
    <header className="relative overflow-hidden" style={{ background: "#0B1030", minHeight: 240 }}>
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1600&h=900&fit=crop&q=80"
          alt=""
          className="w-full h-full object-cover"
          style={{ objectPosition: "center 40%" }}
        />
        <div className="absolute inset-0" style={{ background: "rgba(11,16,48,0.84)" }} />
      </div>

      <div
        className="relative z-10 max-w-[1180px] mx-auto px-5 md:px-16"
        style={{ paddingTop: "clamp(96px,11vw,124px)", paddingBottom: 36 }}
      >
        <button
          onClick={() => navigate("/flights")}
          className="inline-flex items-center gap-2 mb-5"
          style={{
            background: "none",
            border: "none",
            color: "rgba(255,255,255,0.65)",
            fontSize: 14,
            fontWeight: 500,
            cursor: "pointer",
            padding: 0,
            fontFamily: "inherit",
          }}
        >
          <IconBack />
          Back to flights
        </button>

        <h1
          style={{
            fontFamily: '"Bricolage Grotesque", sans-serif',
            fontSize: "clamp(32px,5vw,54px)",
            fontWeight: 800,
            color: "#fff",
            letterSpacing: -1.5,
            lineHeight: 1,
          }}
        >
          {from}
          <span style={{ color: ORANGE, margin: "0 12px" }}>→</span>
          {to}
        </h1>

        <div className="flex flex-wrap items-center gap-3 mt-4">
          {cabin && (
            <span
              style={{
                background: "rgba(255,255,255,0.12)",
                backdropFilter: "blur(8px)",
                border: "1px solid rgba(255,255,255,0.22)",
                color: "#fff",
                fontSize: 13,
                fontWeight: 600,
                padding: "5px 14px",
                borderRadius: 999,
                textTransform: "capitalize",
              }}
            >
              {cabin.toLowerCase()}
            </span>
          )}
          {depDate && (
            <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 14 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ display: "inline", verticalAlign: -2, marginRight: 5 }}>
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" />
              </svg>
              {depDate}
            </span>
          )}
          <span
            style={{
              background: "rgba(255,106,26,0.18)",
              color: "#FFB98A",
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: ".4px",
              textTransform: "uppercase",
              padding: "4px 12px",
              borderRadius: 999,
              border: "1px solid rgba(255,106,26,0.3)",
            }}
          >
            Review &amp; pay
          </span>
        </div>
      </div>
    </header>
  );
};
export default Banner;
